
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { login } from '@api/connectors/cloud1C'

const TASKS = [
    {
        title: 'Перейдите в чат поддержки',
        body: 'Например: <a href="https://t.me/salon1c_support_bot" target="_blank" rel="noopener noreferrer">https://t.me/salon1c_support_bot</a>',
    },
    {
        title: 'Напишите любое слово в бот',
        body: 'Например: «Добрый день!»',
    },
    {
        title: 'Выберите «Другой вопрос»',
        body: 'В появившемся меню выберите нужный пункт.',
    },
    {
        title: 'Отправьте запрос',
        body: 'Попросите прислать ключ API и ID филиалов для облачной версии 1C:Салон красоты.',
    },
    {
        title: 'Вставьте данные справа',
        body: 'Ключ API и ID филиалов нужны для завершения подключения.',
    },
]

export default {
    name: 'Cloud1CAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const validLogin = ref<boolean | null>(null)
        const creds = ref({ apiKey: '', salonId: '' })
        const loading = ref(false)

        const currentAddingConnector = computed(
            () => store.state.project.currentAddingConnector
        )

        const btnDisabled = computed(() =>
            Object.values(creds.value).some((v) => !String(v || '').trim())
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const adding = currentAddingConnector.value
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: adding?.type ?? adding,
            })
            const isLogin = await login(connector, creds.value)

            if (isLogin) {
                store.commit(
                    'project/setLoggedAddingConnector',
                    Object.assign(connector, { salonId: creds.value.salonId })
                )
                root.$parent.$emit('login')
            }
            validLogin.value = isLogin
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Войти',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            validLogin,
            creds,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
